<template>
  <div class="flex flex-col">
    <div class="flex w-full gap-4 mt-2 flex-col sm:flex-row align-center">
      <RadioGroup v-model="localSelectedOfferSku" class="w-full">
        <RadioGroupLabel class="font-bold text-xl pb-2 tracking-tight text-gray-900">Formule</RadioGroupLabel>
        <div
          :class="[
            hasManyOffers ? 'grid grid-cols-2 md:grid-cols-3 gap-3 mt-2' : 'flex gap-4 mt-2 flex-col sm:flex-row',
          ]"
        >
          <RadioGroupOption
            as="template"
            v-for="offer in offers"
            :key="offer.contractSku"
            :value="offer.contractSku"
            v-slot="{ checked }"
          >
            <div
              :class="[
                checked ? 'border-primary ring-2 ring-primary' : 'border-gray-300',
                'relative flex border bg-white p-4 shadow-xs focus:outline-hidden rounded-3xl cursor-pointer',
                hasManyOffers ? 'min-w-0 w-full' : 'grow',
              ]"
            >
              <span class="flex flex-1">
                <span class="flex flex-col">
                  <template v-if="isMpcpCategory && offer.monthly && offerDisplay(offer)">
                    <p class="block text-sm font-bold" :class="getMpcpOfferColor(offer.offerMarketingTitle)">
                      {{ offerDisplay(offer) }}
                    </p>
                  </template>
                  <template v-else>
                    <div class="flex items-center gap-2 flex-wrap">
                      <span class="block text-md font-light text-gray-900">{{ offerDisplayTermLength(offer) }}</span>
                    </div>
                  </template>
                  <div class="mt-1 flex flex-col text-md text-gray-500" v-if="offer.monthly">
                    <p class="font-bold text-sm text-black">{{ formatPrice(offer.price) }} / mois</p>
                    <p v-if="isMpcpCategory" class="text-gray-500 text-xs italic">
                      {{ formatPrice(offer.price * 12) }} par an
                    </p>
                  </div>
                  <span class="font-bold text-sm text-black" v-else>{{ formatPrice(offer.price) }}</span>
                  <span class="mt-1 flex items-center text-xs text-gray-500">{{ offer.sku }}</span>
                  <span
                    v-if="isRecommendedOffer(offer)"
                    class="inline-flex items-center px-2 py-0.5 rounded-sm text-xs font-medium bg-primary text-button-font-primary"
                  >
                    Recommandé
                  </span>
                </span>
              </span>
              <CheckCircleIcon :class="[!checked ? 'invisible' : '', 'h-5 w-5 text-primary-dark']" aria-hidden="true" />
              <span
                :class="[
                  checked ? 'border border-primary' : 'border-2 border-transparent',
                  'pointer-events-none absolute -inset-px rounded-3xl cursor-pointer',
                ]"
                aria-hidden="true"
              />
            </div>
          </RadioGroupOption>
        </div>
      </RadioGroup>
    </div>
  </div>
</template>

<script>
import { RadioGroup, RadioGroupLabel, RadioGroupOption } from "@headlessui/vue";
import { CheckCircleIcon } from "@heroicons/vue/outline";
import { formatPrice, formatDuration, getMpcpOfferColor } from "@estaly/ui";

export default {
  components: {
    RadioGroup,
    RadioGroupLabel,
    RadioGroupOption,
    CheckCircleIcon,
  },

  props: {
    offers: Array,
    selectedOfferSku: String,
    /** Quand fourni (ex: SubscriptionFormWithSteps), affiche "Recommandé" sur l'offre correspondante. */
    recommendedOfferSku: {
      type: String,
      default: null,
    },
    isMpcpCategory: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      localSelectedOfferSku: this.selectedOfferSku,
    };
  },

  computed: {
    hasManyOffers() {
      return (this.offers || []).length >= 5;
    },
  },

  watch: {
    localSelectedOfferSku(newVal) {
      this.$emit("update:selectedOfferSku", newVal);
    },

    selectedOfferSku(newVal) {
      this.localSelectedOfferSku = newVal;
    },
  },

  methods: {
    formatPrice,
    formatDuration,
    getMpcpOfferColor,

    isRecommendedOffer(offer) {
      return (
        this.recommendedOfferSku != null &&
        this.recommendedOfferSku !== "" &&
        offer?.contractSku === this.recommendedOfferSku
      );
    },

    offerDisplay(offer) {
      return offer.offerMarketingTitle;
    },

    offerDisplayTermLength(offer) {
      if (offer.monthly) return "Paiement mensuel";
      return offer.recurring ? "Paiement annuel" : formatDuration(offer.termLength);
    },
  },
};
</script>
